import {CookieHandler} from "@/helpers/CookieHandler";
import { webappLink} from "@/services/endpoints";
import {domainFolder, isSecure} from "@/helpers/DomainHelpers";
import {COOKIE_TOKEN} from "@/constants/cookies";


const cookies: CookieHandler = new CookieHandler(7, webappLink(), domainFolder(), isSecure());

export const getToken = (): string => cookies.get(COOKIE_TOKEN);
export const setToken = (token: string) => cookies.set(COOKIE_TOKEN, token);
export const removeToken = () => cookies.remove(COOKIE_TOKEN);

